(function(){
  var style = document.createElement('style');
  style.textContent =
    '#cm-options, #cm-form-skeleton { display: none !important; }' +
    'body.phybra-personalizer-open #cm-options, body.phybra-personalizer-open #cm-form-skeleton { display: block !important; }';
  document.head.appendChild(style);

  function attach(){
    var details = document.querySelector('.phybra-acc-cta');
    if (!details) return false;
    function sync(){
      document.body.classList.toggle('phybra-personalizer-open', details.hasAttribute('open'));
    }
    sync();
    details.addEventListener('toggle', sync);
    return true;
  }
  if (attach()) return;
  var obs = new MutationObserver(function(){ if (attach()) obs.disconnect(); });
  obs.observe(document.body, {childList:true, subtree:true});
  setTimeout(function(){ obs.disconnect(); }, 20000);
})();
